import type {
    DocsLanguage
} from "../i18n";
import type {
    GapPropagationType,
    SharpnessType
} from "ncore-ui-kit";

export type BlockSettings = {
    gapPropagation: GapPropagationType;
    sharpness: SharpnessType;
    language: DocsLanguage;
    paletteKey: string;
    themeKey: string;
};

export type BlockViewport = "desktop" | "tablet" | "phone";

export const BLOCK_VIEW_PATH = "/view/";

export const BLOCK_MESSAGE_SOURCE = "ncore-block-settings";

export const BLOCK_SHARPNESSES: Array<SharpnessType> = [
    "soft",
    "sharp",
    "rounded"
];

export const BLOCK_DENSITIES: Array<GapPropagationType> = [
    "spacious",
    "compact"
];

export const getBlockViewUrl = (id: string, settings: BlockSettings) => {
    const params = new URLSearchParams({
        density: settings.gapPropagation,
        sharpness: settings.sharpness,
        palette: settings.paletteKey,
        lang: settings.language,
        theme: settings.themeKey
    });

    return `${BLOCK_VIEW_PATH}${id}?${params.toString()}`;
};

export const getBlockViewId = (pathname: string) => {
    if(!pathname.startsWith(BLOCK_VIEW_PATH)) {
        return null;
    }

    return pathname.slice(BLOCK_VIEW_PATH.length).split("/")[0] || null;
};

export const readBlockViewParams = (search: string) => {
    const params = new URLSearchParams(search);

    const requestedLanguage = params.get("lang");

    const language: DocsLanguage | undefined = requestedLanguage === "en" || requestedLanguage === "tr" ? requestedLanguage : undefined;

    return {
        gapPropagation: params.get("density"),
        sharpness: params.get("sharpness"),
        paletteKey: params.get("palette"),
        themeKey: params.get("theme"),
        language
    };
};
